<template>
  <div class="col-md-4  pb-3">
    <div class="card" style="z-index: 0">
      <div class="cover" :class="[quiz.picture && 'cover-custom-img']" @click="previewImg">
        <img v-if="quiz.picture" class="card-img-top"
             v-show="imageLoaded"
             @load="imageLoaded = true"
             alt=""
             :src="quiz.picture.picture_thumb_module">

        <img class="card-img-top"
             v-show="!imageLoaded"
             alt=""
             src="@/assets/app/media/img/misc/placeholder.png">
      </div>
      <div class="card-body">
        <h6 class="card-title ellipsis" v-encode="quiz.name" @click="goToQuiz"></h6>
        <div class="card-text">
          <div class="m-widget19__action d-flex justify-content-center mt-4">
            <button v-if="!quiz.result"
                    @click="goToQuiz"
                    type="button"
                    class="btn m-btn--pill m-btn m-btn--custom btn-outline-light btn-ls m-btn--hover-ls">
              {{ isQuiz ? $t('Start quiz') : $t('Take survey') }} {{ extendedButtonText }}
            </button>
            <button v-else
                    @click="goToQuiz"
                    type="button"
                    class="btn m-btn--pill m-btn m-btn--custom btn-outline-ls">
              {{ $t('See') }} {{ extendedButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Encode from "@/directives/encode";
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "Quiz",
    props: {
      quiz: Object,
      extendedButton: Boolean,
      returnPage: String,
      returnStatus: [String, Number],
      returnShowOnPage: [String, Number],
    },
    directives: {
      Encode,
      ClickOutside,
    },
    data() {
      return {
        imageLoaded: false,
      }
    },
    methods: {
      goToQuiz() {
        const name = this.quiz.type === 0
            ? 'QuizPage'
            : 'PollPage';

        let push = { name, params: { id:this.quiz.id } };

        if (this.returnPage) {
          push.query = {
            return: this.returnPage,
            status: this.returnStatus,
            showOnPage: this.returnShowOnPage
          };
        }
        this.$router.push(push)
      },
      previewImg() {
        if (this.quiz.picture) {
          this.$imgPreview({
            img: this.quiz.picture.picture,
          })
        }
      },
    },
    computed: {
      isQuiz() {
        return this.quiz.type === 0
      },
      extendedButtonText() {
        if (this.extendedButton) {
          return this.quiz.type === 0 ? this.$t('Quiz') : this.$t('Survey');
        }

        return '';
      }
    }
  }
</script>

<style scoped>
  .result-date {
    color: #7a7a7a;
  }

  .shadow {
    background-color: green;
    -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-title {
    cursor: pointer;
  }

  .cover {
    position: relative; /* Not required now */
    float: left;
    -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  }

  .cover img {
    display: block;
    position: relative;
    z-index: -1;
  }

  .cover-custom-img:hover {
    background: rgba(1, 1, 1, 0.1);
    cursor: pointer;
    position: relative;
  }

  .cover-custom-img:hover:before {
    cursor: pointer;
    font-family: "Font Awesome 5 Free", serif;
    font-weight: 900;
    font-size: 60px;
    content: "\F00E";
    color: white;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 40px;
    height: 80px;
  }

  .hidden {
    display: none !important;
  }

  .close {
    width: 23px;
    height: 23px;
    margin-top: -15px;
    margin-right: -5px;
  }
</style>
